import React, { Component, Children } from 'react';
import styles from './styles.scss';

import img_ico_detial from '../../static/views/ico_detial.png';


class ListItem extends Component
{
  constructor(props) {
    super(props);
    console.log(props)
  }
  
  render()
  {
    let content = this.props.content;
    return(
      <div className={styles["list_item"]}>
        <div className={styles.title}>{content.name}</div>
        <div className={styles.text}>
          {content.desc}
          {content.person_count && (<div>人數：{content.person_count}</div>) }
        </div>
        {
          this.props.content.action &&  (
              <div className={styles.ico_right}>
                <img src={img_ico_detial} alt="詳細頁"/>
              </div>
            )
        }
        {
          this.props.children && Children.only(this.props.children)
        }
        
        
      </div>
    );
  }
}

export default ListItem;


// WEBPACK FOOTER //
// ./src/components/ListItem/ListItem.js